import React from "react";
import { connect } from "react-redux";

class TermsAndCondition extends React.Component {
  render() {
    return (
      <div className="auth-footer">
        {[
          {
            title: "Privacy Policy",
            url: "https://dataintegrated.co.ke/privacy-policy",
          },
          {
            title: "Cookie Policy",
            url: "https://dataintegrated.co.ke/cookie-policy",
          },
          {
            title: "Terms & Conditions",
            url: "https://dataintegrated.co.ke/terms",
          },
        ].map((el, i) => {
          return (
            <div
              className="auth-footer-item"
              key={i}
              text={el.title}
              onClick={() => window.open(el.url, "_blank")}
            >
              <span>{el.title}</span>
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(TermsAndCondition);
